import { render } from "./StudentPayment.vue?vue&type=template&id=08f9ee37&scoped=true"
import script from "./StudentPayment.vue?vue&type=script&lang=js"
export * from "./StudentPayment.vue?vue&type=script&lang=js"

import "./StudentPayment.vue?vue&type=style&index=0&id=08f9ee37&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f9ee37"]])

export default __exports__